<template>
  <div>
    <nav
      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      style="height: 50px;"
    >
    </nav>
    <div class="flex flex-col md:flex-row">
      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">
        <div class="bg-blue-800 p-2 shadow text-xl text-white">
          <div class="bg-grey-lighter min-h-screen flex flex-col">

            <!-- eslint-disable max-len -->
            <div
              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
            >
            <!-- eslint-enable max-len -->
              <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full">
                <img class="m-auto mb-10" src="@/assets/musicverse-logo.png" style="width: 150px"/>
                <h1 class="mb-8 text-3xl text-center" >Set your new password</h1>
                <!-- eslint-disable max-len -->
                <form @submit="submitChangePassword" autocomplete="off" >
                  <div v-if="!successResetPassword" >
                    <p v-if="$v.password.$dirty && !$v.password.required" class="text-red-500 text-xs italic text-left">Please fill the password.</p>
                    <div class="relative">
                      <input
                        :type="showPassword?'text':'password'"
                        class="block border border-grey-light w-full p-3 rounded mb-4"
                        name="password"
                        placeholder="Password"
                        v-model="password"
                        autocomplete="off"
                      />
                      <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">
                        <font-awesome-icon class="text-blue-500" :icon="['fa', showPassword?'eye-slash':'eye']" />
                      </a>
                    </div>
                    <p v-if="$v.repassword.$dirty && !$v.repassword.required" class="text-red-500 text-xs italic text-left">Please fill the confirm password.</p>
                    <p v-if="$v.repassword.$dirty && !$v.repassword.sameAsPassword" class="text-red-500 text-xs italic text-left">Please fill correct the confirm password.</p>
                    <div class="relative">
                      <input
                        :type="showConfirmPassword?'text':'password'"
                        class="block border border-grey-light w-full p-3 rounded mb-4"
                        name="confirm_password"
                        placeholder="Confirm Password"
                        v-model="repassword"
                        autocomplete="off"
                      />
                      <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showConfirmPassword=!showConfirmPassword" style="cursor:pointer">
                        <font-awesome-icon class="text-blue-500" :icon="['fa', showConfirmPassword?'eye-slash':'eye']" />
                      </a>
                    </div>
                    <button
                      type="submit"
                      @click="submitChangePassword"
                      :disabled="isLoading"
                      class="w-full content-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1"
                    >
                      <!-- <font-awesome-icon v-if="isLoading" :icon="['fa', 'spinner']" size="2x" class="pt-3 pr-0 md:pr-3 animate-spin" /> -->
                      {{ labelForgotPassword }}<img v-if="isLoading" src="@/assets/bars.svg" width="30px" class="m-auto" />
                    </button>
                  </div>
                  <div v-if="successResetPassword" >
                    <h1 class="mb-8 text-2xl text-center" >Reset password success!</h1>
                    <div class="text-base" >Click <router-link class="text-blue-400 cursor-pointer" :to="{ name: 'Signin' }" >here</router-link> to login with new password</div>
                  </div>
                </form>
                <!-- eslint-enable max-len -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'ForgotPassword',
  mixins: [validationMixin],
  data: () => ({
    isLoading: true,
    successResetPassword: false,
    showPassword: false,
    showConfirmPassword: false,
    email: '',
    password: '',
    repassword: '',
  }),
  validations: {
    password: {
      required,
    },
    repassword: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  props: {
    t: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.email = atob(this.t).split('#')[0];
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    labelForgotPassword() {
      return this.isLoading ? '' : 'Submit';
    },
  },
  watch: {
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
  },
  methods: {
    ...mapActions('AuthModule', ['requestChangePassword']),
    async submitChangePassword() {
      try {
        await this.requestChangePassword({ email: this.email, password: this.password });
        this.successResetPassword = true;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ChangePassword.vue